// extracted by mini-css-extract-plugin
export var cardContainer = "article-list-module--cardContainer--4c9ac";
export var container = "article-list-module--container--c9687";
export var description = "article-list-module--description--6c80d";
export var genericContainer = "article-list-module--genericContainer--0ea4e";
export var image = "article-list-module--image--0b2f0";
export var title = "article-list-module--title--3fa6c";
export var wrapper = "article-list-module--wrapper--91e74";